import refreshToken from '@/utils/refreshToken';
export default async (error) => {
    if (error && error.status == 401) {
        await refreshToken(error);
        return Promise.resolve(true);
    }
    return Promise.reject(error);
}